export const isNullOrZero = (value: number | undefined | null) => value == null || value === 0

export const safeParseInt = (value: unknown, fallback?: number) => {
  if (typeof value === 'number') {
    return value
  }
  if (value == null || typeof value !== 'string') {
    return fallback
  }
  const parsedValue = Number.parseInt(value)
  return Number.isNaN(parsedValue) ? fallback : parsedValue
}

export const getHoursMinutesSecondsFromSeconds = (timeInSeconds: number): [number, number, number] => {
  const seconds = timeInSeconds % 60
  const minutes = ((timeInSeconds - seconds) / 60) % 60
  const hours = (timeInSeconds - seconds - minutes * 60) / 60 / 60
  return [hours, minutes, seconds]
}

export const isNumeric = (value: unknown) => {
  var regexOnlyNumbers = /^\d+$/
  return typeof value !== 'object' && regexOnlyNumbers.test(value + '')
}

export const formatTime = (seconds: number): string => {
  seconds = Math.floor(seconds) // Ensure it's an integer

  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  const paddedMins = String(mins).padStart(2, '0')
  const paddedSecs = String(secs).padStart(2, '0')
  const paddedHrs = String(hrs).padStart(2, '0')

  return isNaN(secs) ? '00:00:00' : `${paddedHrs}:${paddedMins}:${paddedSecs}`

  // if (hrs > 0) {
  //   const paddedHrs = String(hrs).padStart(2, '0')
  //   return `${paddedHrs}:${paddedMins}:${paddedSecs}`
  // } else {
  //   return `${mins}:${paddedSecs}`
  // }
}
